import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { logout_icon } from "../assets/imgs";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import apiRequest from "../screens/redux/api/apiRequest";
import { useLazyLogoutQuery } from "../screens/redux/api/api";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { toast } from "react-toastify";
import DatasetLinkedIcon from "@mui/icons-material/DatasetLinked";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import ThunderstormIcon from "@mui/icons-material/Thunderstorm";
import PersonIcon from "@mui/icons-material/Person";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DevicesIcon from "@mui/icons-material/Devices";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import BusinessIcon from "@mui/icons-material/Business";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ViewStreamIcon from "@mui/icons-material/ViewStream";
import CampaignIcon from "@mui/icons-material/Campaign";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import CameraIcon from "@mui/icons-material/Camera";
import AppsIcon from "@mui/icons-material/Apps";
import TabletMacIcon from "@mui/icons-material/TabletMac";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";
import GroupsIcon from "@mui/icons-material/Groups";
import SettingsIcon from "@mui/icons-material/Settings";
import { get } from "../Services/ApiHandler";
import { URL } from "../Services/Constant";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import LinkedCameraOutlinedIcon from "@mui/icons-material/LinkedCameraOutlined";
const ProfileNavBar = ({ setRoleText }) => {
  // All Dropdowns

  const [saideBarShow, setSaidBarShow] = useState(true);
  const givenpermissions = JSON.parse(
    localStorage.getItem("user_permission") ?? "[]",
  );
  const givenuser = JSON.parse(localStorage.getItem("user_details"));
  const loginType = localStorage.getItem("type");
  const company = JSON.parse(localStorage.getItem("company"));
  const companyName = company?.name;
  const [reportOpen, setReportOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [loader, setLoader] = useState(false);
  const [popup, setPopup] = useState();
  const [toggle, setToggle] = useState(null);
  const [profileDrop, setProfileDrop] = useState(false);
  const [logout] = useLazyLogoutQuery();
  const handleToggle = (menu) => {
    setToggle(toggle === menu ? null : menu);
  };

  const [notiCount, setNotiCount] = useState(0);

  useEffect(() => {
    if (givenuser?.knf_type == 1) {
      setToggle("company");
    }
    if (givenuser?.knf_type == 2) {
      setToggle("site-admin");
    }

    if (givenuser?.knf_type >= 3 && givenuser?.knf_type <= 5) {
      setToggle("group");
    }

    if (
      givenuser?.role?.id &&
      !givenuser?.knf_role?.id &&
      !givenuser?.knf_type
    ) {
      setToggle("weather");
    }

    if (
      givenuser?.knf_role?.id &&
      !givenuser?.role?.id &&
      !givenuser?.knf_type
    ) {
      setToggle("camera");
    }
  }, []);

  const handleLogout = async () => {
    setLoader(true);
    toast.success("Logout Successfully");
    localStorage.clear();
    setTimeout(() => {
      setLoader(false);
      setPopup(false);
      navigate("/");
    }, 500);

    // const res = await apiRequest(logout);
    // if (res?.status == "success") {
    //   localStorage.clear();
    // }

    // console.log(res);
  };

  const toggle_nav = () => {
    setSaidBarShow(!saideBarShow);
  };

  const profileDropDown = () => {
    setProfileDrop(true);
  };

  const onClose = () => {
    setProfileDrop(false);
  };

  const getNotificationCount = () => {
    if (givenuser?.knf_type >= 1 && givenuser?.knf_type <= 5) {
      get(URL.USER_NOTIFICATION_COUNT)
        .then((res) => {
          if (res?.status == "success") {
            setNotiCount(res?.notification_count);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      get(URL.ADMIN_NOTIFICATION_COUNT)
        .then((res) => {
          if (res?.status == "success") {
            setNotiCount(res?.notification_count);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  useEffect(() => {
    getNotificationCount();
  }, []);

  return (
    <div className={`${saideBarShow ? " sidebar" : "close_sidebar  "} `}>
      <div
        onClick={() => {
          toggle_nav();
        }}
        className=""
      >
        {saideBarShow ? (
          <KeyboardDoubleArrowRightIcon className="arrow-right" />
        ) : (
          ""
        )}
      </div>
      <div
        onClick={() => {
          toggle_nav();
        }}
        className=""
      >
        {saideBarShow ? (
          ""
        ) : (
          <KeyboardDoubleArrowLeftIcon className="arrow-left" />
        )}
      </div>

      <div className="menu_bar overflow-x-hidden overflow-scroll">
        <div className="menu">
          <ul className="menu_links ps-0">
            {/* {givenpermissions?.includes("CAN-List-ADMINS") && ( */}
            {(givenuser?.role?.id &&
              givenuser?.role?.guard_name == "admin" &&
              givenpermissions?.includes("CAN-List-ADMINS")) ||
            (givenuser?.knf_role?.id &&
              givenuser?.knf_role?.guard_name == "admin" &&
              givenpermissions?.includes("CAN-List-KNF_ADMIN")) ? (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/admin-list");
                  setRoleText("knf");
                  setToggle(null);
                }}
              >
                <h4
                  className={` ${
                    splitLocation[1] === "admin-list" ||
                    splitLocation[1] === "add-user-list"
                      ? " f3 active_bar"
                      : " "
                  } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  <PersonIcon />
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                    Admin
                  </span>
                </h4>
              </li>
            ) : null}
            {companyName ||
            givenuser?.knf_type == 1 ||
            (givenuser?.knf_type >= 3 && givenuser?.knf_type <= 5) ? (
              <li
                className="nav_link trans"
                onClick={() => {
                  onClose();
                  setToggle(null);
                  if (givenuser?.knf_type >= 1 && givenuser?.knf_type <= 5) {
                    if (
                      givenuser?.type ||
                      (givenuser?.knf_type == 1 && !givenuser?.type)
                    ) {
                      setRoleText("knf");
                      navigate(companyName + "/manager");
                    } else {
                      setRoleText("aiware");
                      navigate("/group-view-profile");
                    }
                  } else {
                    setRoleText("knf");
                    navigate(companyName + "/manager");
                  }
                }}
              >
                <h4
                  className={` ${
                    splitLocation[1] === "admin-list" ||
                    splitLocation[1] === "add-user-list"
                      ? " f3 active_bar"
                      : " "
                  } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  <PersonIcon />
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                    {loginType == "Company Sub Admin"
                      ? "Profile"
                      : loginType == "Company User"
                        ? // ? "User"
                          "Profile"
                        : loginType == "Company Manager" ||
                            givenuser?.knf_type == 1 ||
                            givenuser?.type == 3
                          ? "Profile"
                          : givenuser?.knf_type >= 3 && givenuser?.knf_type <= 5
                            ? "Profile"
                            : "Profile"}
                  </span>
                </h4>
              </li>
            ) : null}
            {givenuser?.role?.id && (
              <li
                className="nav_link trans mb-0"
                onClick={() => {
                  handleToggle("weather");
                  setRoleText("knf");

                  if (
                    givenpermissions?.includes("COMPANY-CAN-List-COMPANY_ROLES")
                  ) {
                    navigate(companyName + "/role");
                  } else if (givenuser?.login_type == "admin") {
                    navigate("/role");
                  } else if (
                    givenuser?.login_type !== "admin" &&
                    givenuser?.role?.type
                  ) {
                    navigate(`/${companyName}/manager`);
                  } else {
                    navigate("/role");
                  }
                }}
              >
                <h4
                  className={` ${
                    splitLocation[1] === "role" ||
                    splitLocation[1] === "add-role" ||
                    splitLocation[1] === "company-role" ||
                    splitLocation[1] === "company-role-add" ||
                    splitLocation[1] === "user-list" ||
                    splitLocation[1] === "daily-log" ||
                    splitLocation[1] === "add-user-list" ||
                    splitLocation[1] === "device-add" ||
                    splitLocation[1] === "device-list" ||
                    splitLocation[1] === "report" ||
                    splitLocation[1] === "notificationreport" ||
                    splitLocation[1] === "members-list" ||
                    splitLocation[1] === "company" ||
                    splitLocation[1] === "location-marks" ||
                    splitLocation[1] === "location-marks-add" ||
                    splitLocation[1] === "device-add" ||
                    splitLocation[1] === "log-file"
                      ? " f3 active_bar"
                      : " "
                  } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  <ThunderstormIcon />
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1 d-flex ac-jb w-100">
                    KNF WAS@SG <ArrowDropDownIcon />
                  </span>
                </h4>
              </li>
            )}
            {toggle === "weather" && (
              <div className={`sub-nav ${toggle === "weather" ? "open" : ""}`}>
                {givenpermissions?.includes("CAN-List-KNF-ROLES") && (
                  <li
                    className="nav_link trans mt-0"
                    onClick={() => {
                      navigate("/role");
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "role" ||
                        splitLocation[1] === "add-role"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <Diversity1Icon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        KNFWAS Role
                      </span>
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-List-COMPANY-ROLES") && (
                  <li
                    className="nav_link trans"
                    onClick={() => {
                      navigate("/company-role");
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "company-role" ||
                        splitLocation[1] === "company-role-add"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <AccountBalanceIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Role Management
                      </span>
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-List-COMPANIES") && (
                  <li
                    className="nav_link trans"
                    onClick={() => {
                      navigate("/company");
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "company" ||
                        splitLocation[1] === "user-list" ||
                        splitLocation[1] === "daily-log" ||
                        splitLocation[1] === "add-user-list"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <SupervisorAccountIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Company
                      </span>
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes("CAN-List-DEVICES") && (
                  <li
                    className="nav_link trans"
                    onClick={() => {
                      navigate("/was-alert-days");
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "was-alert-days"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <CampaignIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Alert Schedule
                      </span>
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes("CAN-List-DEVICES") && (
                  <li
                    className="nav_link trans"
                    onClick={() => {
                      navigate("/device-list");
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "device-add" ||
                        splitLocation[1] === "device-list" ||
                        splitLocation[1] === "report" ||
                        splitLocation[1] === "notificationreport" ||
                        splitLocation[1] === "members-list"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <DevicesIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Device List
                      </span>
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-List-LOCATIONS") && (
                  <li
                    className="nav_link trans"
                    onClick={() => {
                      navigate("/location-marks");
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "location-marks" ||
                        splitLocation[1] === "location-marks-add"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <LocationOnIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Location Marks
                      </span>
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-List-LOGS") && (
                  <li
                    className="nav_link trans"
                    onClick={() => {
                      navigate("/log-file");
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "device-add" ||
                        splitLocation[1] === "log-file"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <DatasetLinkedIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Daily Log Report
                      </span>
                    </h4>
                  </li>
                )}
                {/* {givenpermissions?.includes("CAN-List-LOGS") && (
                  <li
                    className="nav_link trans"
                    onClick={() => {
                      navigate("/log-file");
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[2] === "manager" ? " f3 active_bar" : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <PersonIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        {loginType == "Company Sub Admin"
                          ? "SubAdmin"
                          : loginType == "Company User"
                          ? "User"
                          : "Manager"}
                      </span>
                    </h4>
                  </li>
                )} */}
                {givenpermissions?.includes(
                  "COMPANY-CAN-List-COMPANY_ROLES",
                ) && (
                  <li
                    className="nav_link trans my-2 d-flex align-items-center"
                    onClick={() => {
                      navigate(companyName + "/role");
                      onClose();
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[2] === "role" ||
                        splitLocation[2] === "add-company-role"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <PersonIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Role
                      </span>
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("COMPANY-CAN-List-COMPANY_USERS") &&
                  loginType != "Company User" && (
                    <li className="nav_link trans my-2 d-flex flex-column">
                      <div
                        className="d-flex align-items-center justify-content-between w-100"
                        onClick={() => profileDropDown()}
                      >
                        <h4
                          className={` ${
                            splitLocation[2] === "sub-admin" ||
                            splitLocation[2] === "users"
                              ? " f3 active_bar"
                              : " "
                          } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                        >
                          <div className="d-flex align-items-center">
                            <PersonIcon className="me-2" />
                            {saideBarShow && (
                              <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                                Profile
                              </span>
                            )}
                          </div>
                          {saideBarShow && (
                            <KeyboardArrowDownIcon
                              className={`ms-auto ${
                                profileDrop ? "rotate-180" : ""
                              }`}
                            />
                          )}
                        </h4>
                      </div>

                      {/* Submenu */}
                      {saideBarShow && profileDrop && (
                        <ul className="submenu my-2 ps-5">
                          {loginType != "Company Sub Admin" && (
                            <li
                              className={`submenu-item pointer my-2  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18  ${
                                splitLocation[2] === "sub-admin"
                                  ? "active_bar"
                                  : ""
                              }`}
                              onClick={() =>
                                navigate(companyName + "/sub-admin")
                              }
                            >
                              <ContactPageIcon className="me-2" />
                              Sub Admin
                            </li>
                          )}

                          <li
                            className={`submenu-item pointer my-2  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18  ${
                              splitLocation[2] === "users" ? "active_bar" : ""
                            }`}
                            onClick={() => navigate(companyName + "/users")}
                          >
                            <GroupsIcon className="me-2" />
                            Members
                          </li>
                        </ul>
                      )}
                    </li>
                  )}

                {givenpermissions?.includes(
                  "COMPANY-CAN-List-COMPANY_DEVICES",
                ) && (
                  <li
                    className="nav_link trans my-2 d-flex align-items-center"
                    onClick={() => {
                      navigate(companyName + "/device-list");
                      onClose();
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[2] === "device-add" ||
                        splitLocation[2] === "report-list" ||
                        splitLocation[2] === "members-list" ||
                        splitLocation[2] === "notification-report-list" ||
                        splitLocation[2] === "device-list"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <TabletMacIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Device List
                      </span>
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes(
                  "COMPANY-CAN-List-COMPANY_DEVICES",
                ) && (
                  <li
                    className="nav_link trans my-2 d-flex align-items-center"
                    onClick={() => {
                      navigate(companyName + "/was-company-alert-days");
                      onClose();
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[2] === "was-company-alert-days"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <CampaignIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Alert Schedule
                      </span>
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes(
                  "COMPANY-CAN-List-COMPANY_LOCATIONS",
                ) && (
                  <li
                    className="nav_link trans my-2 d-flex align-items-center"
                    onClick={() => {
                      navigate(companyName + "/location-marks");
                      onClose();
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[2] === "location-marks"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <WhereToVoteIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Location Marks
                      </span>
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes(
                  "COMPANY-CAN-List-COMPANY_LOGS",
                ) && (
                  <li
                    className="nav_link trans my-2 d-flex align-items-center"
                    onClick={() => {
                      navigate(companyName + "/daily-log");
                      onClose();
                    }}
                  >
                    <h4
                      className={` ${
                        splitLocation[2] === "daily-log"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <DatasetLinkedIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Daily Log Report
                      </span>
                    </h4>
                  </li>
                )}
              </div>
            )}

            {givenuser?.knf_role?.id && !givenuser?.knf_type && (
              <li
                className="nav_link trans mb-0"
                onClick={() => {
                  setRoleText("aiware");
                  handleToggle("camera");
                }}
              >
                <h4
                  className={` ${
                    splitLocation[1] === "admin-dashboard" ||
                    splitLocation[1] === "super-admin-roles" ||
                    splitLocation[1] === "superadmin-company-roles" ||
                    splitLocation[1] === "superadmin-company-roles-view" ||
                    splitLocation[1] === "superadmin-company-roles" ||
                    splitLocation[1] === "superadmin-company-roles-view" ||
                    splitLocation[1] === "admin-company-list" ||
                    splitLocation[1] === "admin-add-company" ||
                    splitLocation[1] === "sites-list" ||
                    splitLocation[1] === "sites-view" ||
                    splitLocation[1] === "alert-types" ||
                    splitLocation[1] === "Overall-notifications" ||
                    splitLocation[1] === "user-report" ||
                    splitLocation[1] === "alert-types-camera" ||
                    splitLocation[1] === "group-users" ||
                    splitLocation[1] === "alert-days" ||
                    splitLocation[1] === "site-report"
                      ? " f3 active_bar"
                      : " "
                  } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  <CameraAltIcon />
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1 d-flex ac-jb w-100">
                    AIWARE <ArrowDropDownIcon />
                  </span>
                </h4>
              </li>
            )}

            {toggle === "camera" && (
              <div className={`sub-nav ${toggle === "camera" ? "open" : ""}`}>
                {givenpermissions?.includes("CAN-List-KNF_ADMIN_DASHBOARD") && (
                  <li
                    className="nav_link trans mt-0"
                    onClick={() => navigate("/admin-dashboard")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "admin-dashboard"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <DashboardCustomizeIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Dashboard
                      </span>
                    </h4>
                  </li>
                )}
                {/* <li
                  className="nav_link trans"
                  onClick={() => navigate("/super-admin-list")}
                >
                  <h4

                    className={` ${splitLocation[1] === "super-admin-list" ||
                      splitLocation[1] === "super-admin-add"
                      ? " f3 active_bar"
                      : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}

                  >
                    <AdminPanelSettingsIcon />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Admin
                    </span>
                  </h4>
                </li> */}

                {givenpermissions?.includes(
                  "CAN-List-KNF_SUPER_ADMIN_ROLES",
                ) && (
                  <li
                    className="nav_link trans"
                    onClick={() => navigate("/super-admin-roles")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "super-admin-roles" ||
                        splitLocation[1] === "super-admin-roles-add"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <GroupWorkIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        AIWARE Roles
                      </span>
                    </h4>
                  </li>
                )}

                {/* {givenpermissions?.includes(
                  "CAN-List-KNF_ADMIN_COMPANY_ROLES",
                ) && (
                  <li
                    className="nav_link trans"
                    onClick={() => navigate("/superadmin-company-roles")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "superadmin-company-roles" ||
                        splitLocation[1] === "superadmin-company-roles-view"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <BusinessIcon />
                      <span className="text f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Company Roles
                      </span>
                    </h4>
                  </li>
                )} */}

                {givenpermissions?.includes("CAN-List-KNF_ADMIN_COMPANY") && (
                  <li
                    className="nav_link trans"
                    onClick={() => navigate("/admin-company-list")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "admin-company-list" ||
                        splitLocation[1] === "admin-add-company"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <FactCheckIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Company
                      </span>
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes("CAN-List-KNF_ADMIN_SITE") && (
                  <li
                    className="nav_link trans"
                    onClick={() => navigate("/sites-list")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "sites-list" ||
                        splitLocation[1] === "sites-view"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <ViewStreamIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Site Management
                      </span>
                    </h4>
                  </li>
                )}

                {/* {givenpermissions?.includes(
                  "CAN-List-KNF_ADMIN_ALERT_TYPE",
                ) && (
                    <li
                      className="nav_link trans"
                      onClick={() => navigate("/alert-types")}
                    >
                      <h4
                        className={` ${splitLocation[1] === "alert-types"
                          ? " f3 active_bar"
                          : " "
                          } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                      >
                        <CampaignIcon />
                        <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                          Alert Types
                        </span>
                      </h4>
                    </li>
                  )} */}
                {(givenpermissions?.includes("CAN-List-KNF_ADMIN_ALERT_TYPE") ||
                  givenpermissions?.includes("CAN-List-KNF_ALERT_ESCALATION") ||
                  givenpermissions?.includes("CAN-List-KNF_CAMERA")) && (
                  <li
                    className="nav_link trans"
                    onClick={() => navigate("/alert-types-camera")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "alert-types-camera"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <LinkedCameraOutlinedIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Alert & Camera
                      </span>
                    </h4>
                  </li>
                )}
                {/* {givenpermissions?.includes(
                  "CAN-List-KNF_ADMIN_ALERT_TYPE",
                ) && ( */}
                {givenpermissions?.includes("CAN-List-KNF_GROUP_USER") && (
                  <li
                    className="nav_link trans"
                    onClick={() => navigate("/group-users")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "group-users"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <Groups2OutlinedIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        User Management
                      </span>
                    </h4>
                  </li>
                )}
                {/* )} */}
                {/* {givenpermissions?.includes(
                  "CAN-List-KNF_ADMIN_ALERT_TYPE",
                ) && ( */}
                {givenpermissions?.includes("CAN-List-KNF_ALERT_DAYS") && (
                  <li
                    className="nav_link trans"
                    onClick={() => navigate("/alert-days")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "alert-days"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <DateRangeOutlinedIcon />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Alert Schedule
                      </span>
                    </h4>
                  </li>
                )}
                {/* )} */}

                {givenpermissions?.includes("CAN-List-KNF_ADMIN_USER_REPORT") ||
                givenpermissions?.includes(
                  "CAN-List-KNF_ADMIN_CONSOLIDATED_REPORT",
                ) ? (
                  <li
                    className="nav_link trans"
                    onClick={() => setReportOpen(!reportOpen)}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "user-report" ||
                        splitLocation[1] === "site-report"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <FolderCopyIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Reports
                      </span>
                    </h4>

                    <KeyboardArrowDownIcon
                      className={`ms-auto ${reportOpen ? "rotate-180" : ""}`}
                    />
                  </li>
                ) : null}
                {/* Submenu */}
                {reportOpen && (
                  <ul className="submenu my-2 ps-5">
                    {givenpermissions?.includes(
                      "CAN-List-KNF_ADMIN_USER_REPORT",
                    ) && (
                      <li
                        className={`submenu-item pointer my-2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18  ${
                          splitLocation[1] === "user-report" ? "active_bar" : ""
                        }`}
                        onClick={() => navigate("/user-report")}
                      >
                        <ContactPageIcon className="me-2" />
                        User Report
                      </li>
                    )}
                    {givenpermissions?.includes(
                      "CAN-List-KNF_ADMIN_CONSOLIDATED_REPORT",
                    ) && (
                      <li
                        className={`submenu-item pointer  my-2 as-js fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18  ${
                          splitLocation[1] === "site-report" ? "active_bar" : ""
                        }`}
                        onClick={() => navigate("/site-report")}
                      >
                        <SpaceDashboardIcon className="me-2" />
                        Site Non-compliance Report
                      </li>
                    )}
                  </ul>
                )}

                {givenpermissions?.includes(
                  "CAN-List-KNF_ADMIN_ALERT_NOTIFICATION",
                ) && (
                  <li
                    className="nav_link trans"
                    onClick={() => navigate("/Overall-notifications")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "Overall-notifications"
                          ? " f3 active_bar"
                          : " "
                      } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex align-items-center`}
                    >
                      <div className="position-relative me-2">
                        <NotificationsActiveIcon />

                        {/* Static Notification Count */}
                        <span
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            background: "red",
                            color: "white",
                            borderRadius: "50%",
                            padding: "2px 6px",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          {notiCount}
                        </span>
                      </div>

                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Alert Notification
                      </span>
                    </h4>
                  </li>
                )}
              </div>
            )}
            {givenuser?.knf_type == 1 && (
              <>
                {/* <li
                  className="nav_link trans mb-0"
                  onClick={() => {
                    handleToggle("company");
                  }}
                >
                  <h4 className="ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18">
                    {givenuser?.knf_role?.id &&
                      givenuser?.knf_type == 1 &&
                      givenuser?.role?.id &&
                      "AIWARE"}
                  </h4>
                </li> */}
                <li
                  className="nav_link trans mb-0"
                  onClick={() => {
                    setRoleText("aiware");
                    handleToggle("company");
                  }}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "company-Dashboard" ||
                      splitLocation[1] === "companyRoles" ||
                      splitLocation[1] === "companyUserRoles" ||
                      splitLocation[1] === "companyUserAddRoles" ||
                      splitLocation[1] === "company-sites" ||
                      splitLocation[1] === "company-sites-view" ||
                      splitLocation[1] === "company-user-report" ||
                      splitLocation[1] === "company-site-report" ||
                      splitLocation[1] === "company-slot" ||
                      splitLocation[1] === "company-alert-types" ||
                      splitLocation[1] === "company-notifications"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <BusinessIcon />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1 d-flex ac-jb w-100">
                      AIWARE
                      <ArrowDropDownIcon />
                    </span>
                  </h4>
                </li>
              </>
            )}
            {toggle === "company" && (
              <div className={`sub-nav ${toggle === "company" ? "open" : ""}`}>
                {givenpermissions?.includes(
                  "CAN-List-KNF_COMPANY_DASHBOARD",
                ) && (
                  <li
                    className="nav_link trans mt-0"
                    onClick={() => navigate("/company-Dashboard")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "company-Dashboard"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <DashboardCustomizeIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Dashboard
                      </span>
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes("CAN-List-KNF_COMPANY_ROLES") && (
                  <li
                    className="nav_link trans "
                    onClick={() => navigate("/companyRoles")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "companyRoles" ||
                        splitLocation[1] === "CompanyAddRoles"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <GroupWorkIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Role Management
                      </span>
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes("CAN-List-KNF_COMPANY_ADMIN") && (
                  <li
                    className="nav_link trans "
                    onClick={() => navigate("/knf-company-admin-list")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "knf-company-admin-list" ||
                        splitLocation[1] === "knf-company-admin-generate"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <AdminPanelSettingsIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Company Admin
                      </span>
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes("CAN-List-KNF_COMPANY_SITE") && (
                  <li
                    className="nav_link trans my-2 d-flex align-items-center"
                    onClick={() => navigate("/company-sites")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "company-sites" ||
                        splitLocation[1] === "company-sites-view"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <ViewStreamIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Sites Management
                      </span>
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes(
                  "CAN-List-KNF_COMPANY_GROUP_USER",
                ) && (
                  <li
                    className="nav_link trans "
                    onClick={() => navigate("/company-group-users-list")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "company-group-users-list"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <Groups2OutlinedIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        User Management
                      </span>
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes(
                  "CAN-List-KNF_COMPANY_USER_ROLES",
                ) && (
                  <li
                    className="nav_link trans "
                    onClick={() => navigate("/companyUserRoles")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "companyUserRoles" ||
                        splitLocation[1] === "companyUserAddRoles`"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <SupervisedUserCircleIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Group Management
                      </span>
                    </h4>
                  </li>
                )}

                {(givenpermissions?.includes(
                  "CAN-List-KNF_COMPANY_ALERT_TYPE",
                ) ||
                  givenpermissions?.includes(
                    "CAN-List-KNF_COMPANY_CAMERA",
                  )) && (
                  <li
                    className="nav_link trans my-2 d-flex align-items-center"
                    onClick={() => navigate("/company-alert-types")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "company-alert-types"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <LinkedCameraOutlinedIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Alert & Camera
                      </span>
                    </h4>
                  </li>
                )}

                {givenpermissions?.includes(
                  "CAN-List-KNF_COMPANY_ALERT_DAYS",
                ) && (
                  <li
                    className="nav_link trans my-2 d-flex align-items-center"
                    onClick={() => navigate("/company-slot")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "company-slot"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <CampaignIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Alert Schedule
                      </span>
                    </h4>
                  </li>
                )}
                {givenpermissions?.includes(
                  "CAN-List-KNF_COMPANY_USER_REPORT",
                ) ||
                givenpermissions?.includes(
                  "CAN-List-KNF_COMPANY_CONSOLIDATED_REPORT",
                ) ? (
                  <li className="nav_link trans my-2 d-flex flex-column">
                    <div
                      className="d-flex align-items-center justify-content-between w-100"
                      onClick={() => setReportOpen(!reportOpen)}
                    >
                      <h4
                        className={` ${
                          splitLocation[1] === "company-site-report" ||
                          splitLocation[1] === "company-user-report"
                            ? " f3 active_bar"
                            : " "
                        } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                      >
                        <div className="d-flex align-items-center">
                          <FolderCopyIcon className="me-2" />
                          {saideBarShow && (
                            <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                              Reports
                            </span>
                          )}
                        </div>
                        {saideBarShow && (
                          <KeyboardArrowDownIcon
                            className={`ms-auto ${
                              reportOpen ? "rotate-180" : ""
                            }`}
                          />
                        )}
                      </h4>
                    </div>

                    {/* Submenu */}
                    {saideBarShow && reportOpen && (
                      <ul className="submenu my-2 ps-5">
                        {givenpermissions?.includes(
                          "CAN-List-KNF_COMPANY_USER_REPORT",
                        ) && (
                          <li
                            className={`submenu-item pointer my-2  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18  ${
                              splitLocation[1] === "company-user-report"
                                ? "active_bar"
                                : ""
                            }`}
                            onClick={() => navigate("/company-user-report")}
                          >
                            <ContactPageIcon className="me-2" />
                            User Report
                          </li>
                        )}
                        {givenpermissions?.includes(
                          "CAN-List-KNF_COMPANY_CONSOLIDATED_REPORT",
                        ) && (
                          <li
                            className={`submenu-item pointer my-2  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18  ${
                              splitLocation[1] === "company-site-report"
                                ? "active_bar"
                                : ""
                            }`}
                            onClick={() => navigate("/company-site-report")}
                          >
                            <SpaceDashboardIcon className="me-2" />
                            Site Non-compliance Report
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                ) : null}

                {givenpermissions?.includes(
                  "CAN-List-KNF_COMPANY_ALERT_NOTIFICATION",
                ) && (
                  <li
                    className="nav_link trans my-2 d-flex align-items-center"
                    onClick={() => navigate("/company-notifications")}
                    style={{ cursor: "pointer" }}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "company-notifications"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <div className="position-relative me-2">
                        <NotificationsActiveIcon />

                        <span
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            background: "red",
                            color: "white",
                            borderRadius: "50%",
                            padding: "2px 6px",
                            fontSize: "10px",
                          }}
                        >
                          {notiCount}
                        </span>
                      </div>
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Alert Notification
                      </span>
                    </h4>
                  </li>
                )}
              </div>
            )}

            {givenuser?.knf_type == 2 && (
              <li
                className="nav_link trans mb-0"
                onClick={() => {
                  setRoleText("aiware");
                  handleToggle("site-admin");
                }}
              >
                <h4
                  className={` ${
                    splitLocation[1] === "site-Dashboard" ||
                    splitLocation[1] === "site-profile" ||
                    splitLocation[1] === "site-user-roles" ||
                    splitLocation[1] === "site-user-add-roles" ||
                    splitLocation[1] === "site-view-profile" ||
                    splitLocation[1] === "site-user" ||
                    splitLocation[1] === "site-alert-types" ||
                    splitLocation[1] === "site-notifications" ||
                    splitLocation[1] === "site-admin-slot" ||
                    splitLocation[1] === "site-admin-report" ||
                    splitLocation[1] === "site-admin-user-report" ||
                    splitLocation[1] === "view-notification-details" ||
                    splitLocation[1] === "site-camera"
                      ? " f3 active_bar"
                      : " "
                  } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  <ViewStreamIcon />
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1 d-flex ac-jb w-100">
                    AIWARE <ArrowDropDownIcon />
                  </span>
                </h4>
              </li>
            )}

            {toggle === "site-admin" && (
              <div
                className={`sub-nav ${toggle === "site-admin" ? "open" : ""}`}
              >
                <li
                  className="nav_link trans mt-0"
                  onClick={() => navigate("/site-Dashboard")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "site-Dashboard"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <DashboardCustomizeIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Dashboard
                    </span>
                  </h4>
                </li>

                {/* <li
                  className="nav_link trans "
                  onClick={() => navigate("/site-view-profile")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "site-view-profile"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <AccountCircleIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Profile
                    </span>
                  </h4>
                </li> */}

                <li
                  className="nav_link trans "
                  onClick={() => navigate("/site-user-roles")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "site-user-roles" ||
                      splitLocation[1] === "site-user-add-roles"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <GroupWorkIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Group Management
                    </span>
                  </h4>
                </li>

                <li
                  className="nav_link trans my-2 d-flex align-items-center"
                  onClick={() => navigate("/site-user")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "site-user" ||
                      splitLocation[1] === "site-group1-user" ||
                      splitLocation[1] === "site-group2-user" ||
                      splitLocation[1] === "site-group3-user"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <CoPresentIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      User Management
                    </span>
                  </h4>
                </li>
                {/* {console.log("givenPermissions", givenpermissions)} */}
                {(givenpermissions?.includes("CAN-List-KNF_COMPANY_CAMERA") ||
                  givenpermissions?.includes(
                    "CAN-List-KNF_COMPANY_ALERT_TYPE",
                  )) && (
                  <li
                    className="nav_link trans my-2 d-flex align-items-center"
                    onClick={() => navigate("/site-alert-types")}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "site-alert-types"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <LinkedCameraOutlinedIcon className="me-2" />
                      <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                        Alert & Camera
                      </span>
                    </h4>
                  </li>
                )}

                <li
                  className="nav_link trans my-2 d-flex align-items-center"
                  onClick={() => navigate("/site-slot")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "site-slot" ? " f3 active_bar" : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <CampaignIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Alert Schedule
                    </span>
                  </h4>
                </li>

                {/* <li
                  className="nav_link trans my-2 d-flex align-items-center"
                  onClick={() => navigate("/site-camera")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "site-camera"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <CameraIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Cameras
                    </span>
                  </h4>
                </li> */}
                <li className="nav_link trans my-2 d-flex flex-column">
                  <div
                    className="d-flex align-items-center justify-content-between w-100"
                    onClick={() => setReportOpen(!reportOpen)}
                  >
                    <h4
                      className={` ${
                        splitLocation[1] === "site-admin-report" ||
                        splitLocation[1] === "site-admin-user-report"
                          ? " f3 active_bar"
                          : " "
                      } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                    >
                      <div className="d-flex align-items-center">
                        <FolderCopyIcon className="me-2" />
                        {saideBarShow && (
                          <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                            Reports
                          </span>
                        )}
                      </div>
                      {saideBarShow && (
                        <KeyboardArrowDownIcon
                          className={`ms-auto ${
                            reportOpen ? "rotate-180" : ""
                          }`}
                        />
                      )}
                    </h4>
                  </div>

                  {/* Submenu */}
                  {saideBarShow && reportOpen && (
                    <ul className="submenu my-2 ps-5">
                      <li
                        className={`submenu-item pointer my-2  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18  ${
                          splitLocation[1] === "site-admin-user-report"
                            ? "active_bar"
                            : ""
                        }`}
                        onClick={() => navigate("/site-admin-user-report")}
                      >
                        <ContactPageIcon className="me-2" />
                        User Report
                      </li>
                      <li
                        className={`submenu-item pointer my-2  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18  ${
                          splitLocation[1] === "site-admin-report"
                            ? "active_bar"
                            : ""
                        }`}
                        onClick={() => navigate("/site-admin-report")}
                      >
                        <SpaceDashboardIcon className="me-2" />
                        Site Non-compliance Report
                      </li>
                    </ul>
                  )}
                </li>

                <li
                  className="nav_link trans my-2 d-flex align-items-center"
                  onClick={() => navigate("/site-notifications")}
                  style={{ cursor: "pointer" }}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "site-notifications" ||
                      splitLocation[1] === "view-notification-details"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <div className="position-relative me-2">
                      <NotificationsActiveIcon />

                      <span
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",
                          background: "red",
                          color: "white",
                          borderRadius: "50%",
                          padding: "2px 6px",
                          fontSize: "10px",
                        }}
                      >
                        {notiCount}
                      </span>
                    </div>
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Alert Notification
                    </span>
                  </h4>
                </li>
              </div>
            )}

            {givenuser?.knf_type >= 3 && givenuser?.knf_type <= 5 && (
              <li
                className="nav_link trans mb-0"
                onClick={() => {
                  setRoleText("aiware");
                  handleToggle("group");
                }}
              >
                <h4
                  className={` ${
                    splitLocation[1] === "group-dashboard" ||
                    splitLocation[1] === "group-new" ||
                    splitLocation[1] === "group-allcoted" ||
                    splitLocation[1] === "group-closed" ||
                    splitLocation[1] === "group-alerts" ||
                    splitLocation[1] === "group-escalations" ||
                    splitLocation[1] === "group-alertdays" ||
                    splitLocation[1] === "group-alertdetails" ||
                    splitLocation[1] === "group-camera"
                      ? " f3 active_bar"
                      : " "
                  } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  <CoPresentIcon />
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1 d-flex ac-jb w-100">
                    AIWARE <ArrowDropDownIcon />
                  </span>
                </h4>
              </li>
            )}
            {toggle === "group" && (
              <div className={`sub-nav ${toggle === "group" ? "open" : ""}`}>
                <li
                  className="nav_link trans mt-0"
                  onClick={() => navigate("/group-dashboard")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "group-dashboard"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <DashboardCustomizeIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Dashboard
                    </span>
                  </h4>
                </li>
                <li
                  className="nav_link trans "
                  onClick={() => navigate("/group-new")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "group-new" ||
                      splitLocation[1] === "group-alertdetails"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <NotificationImportantIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      New Alerts
                    </span>
                  </h4>
                </li>

                <li
                  className="nav_link trans "
                  onClick={() => navigate("/group-allcoted")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "group-allcoted" ||
                      splitLocation[1] === "group-assign-alertdetails"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <AssignmentTurnedInIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Assigned Alerts
                    </span>
                  </h4>
                </li>

                <li
                  className="nav_link trans my-2 d-flex align-items-center"
                  onClick={() => navigate("/group-closed")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "group-closed" ||
                      splitLocation[1] === "group-close-alertdetails"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <CheckCircleIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Closed Alerts
                    </span>
                  </h4>
                </li>

                <li
                  className="nav_link trans my-2 d-flex align-items-center"
                  onClick={() => navigate("/group-alerts")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "group-alerts"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <CampaignIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Alert Types
                    </span>
                  </h4>
                </li>

                <li
                  className="nav_link trans my-2 d-flex align-items-center"
                  onClick={() => navigate("/group-camera")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "group-camera"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <CameraIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Cameras
                    </span>
                  </h4>
                </li>

                <li
                  className="nav_link trans my-2 d-flex align-items-center"
                  onClick={() => navigate("/group-escalations")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "group-escalations"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <ScheduleIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Escalation Time
                    </span>
                  </h4>
                </li>

                <li
                  className="nav_link trans my-2 d-flex align-items-center"
                  onClick={() => navigate("/group-alertdays")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "group-alertdays"
                        ? " f3 active_bar"
                        : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <CampaignIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      Alert Schedule
                    </span>
                  </h4>
                </li>
              </div>
            )}

            {(givenuser?.role?.id && givenuser?.role?.guard_name == "admin") ||
            (givenuser?.knf_role?.id &&
              givenuser?.knf_role?.guard_name == "admin") ? (
              <li
                className="nav_link trans mb-0"
                onClick={() => {
                  handleToggle("settings");
                  navigate("/in-app");
                }}
              >
                <h4
                  className={` ${
                    splitLocation[1] === "in-app" ? " f3 active_bar" : " "
                  } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  <SettingsIcon />
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1 d-flex ac-jb w-100">
                    Settings <ArrowDropDownIcon />
                  </span>
                </h4>
              </li>
            ) : null}

            {toggle == "settings" && (
              <div className={`sub-nav ${toggle === "settings" ? "open" : ""}`}>
                <li
                  className="nav_link trans mt-0"
                  onClick={() => navigate("/in-app")}
                >
                  <h4
                    className={` ${
                      splitLocation[1] === "in-app" ? " f3 active_bar" : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    <DashboardCustomizeIcon className="me-2" />
                    <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                      In-App-Purchase
                    </span>
                  </h4>
                </li>
              </div>
            )}

            {/* {billing !== null && (
              <div className=" nav-dropdown">
                <li
                  className="nav_link text-center trans sidebar-drop"
                  onClick={() => {
                    navigate("/billing-counter");
                    setBilling(1);
                  }}
                >
                  <p
                    className={` ${
                      (activeTabs == 0 && billing == 1) ||
                      splitLocation[1] === "billing-counter" ||
                      splitLocation[1] === "add-billing-counter"
                        ? " active_bar_drop f3"
                        : " green1  "
                    } trans m-0  f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    Billing Master
                  </p>
                </li>
                <li
                  className="nav_link text-center trans sidebar-drop"
                  onClick={() => {
                    navigate("/billing-counter-list");
                    setBilling(2);
                  }}
                >
                  <p
                    className={` ${
                      (activeTabs == 0 && billing == 2) ||
                      splitLocation[1] === "billing-counter-list"
                        ? "active_bar_drop f3"
                        : "green1 "
                    } trans m-0  f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                  >
                    Billing List
                  </p>
                </li>
              </div>
            )} */}
          </ul>
        </div>
      </div>
      <div
        className="d-flex ac-je pt-2 pe-2 pointer"
        onClick={() => setPopup(true)}
      >
        <img src={logout_icon} className="icon " alt="" />
        <h4 className=" f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0">
          Logout
        </h4>
      </div>
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <h2 className="f4 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary mt-4">
              Logout
            </h2>
            <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Logout?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="no-btn">
                No
              </button>
              <button
                onClick={() => {
                  handleLogout();
                }}
                className="yes-btn f2"
              >
                {loader && <div className="border-spinner "></div>}
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileNavBar;
